// extracted by mini-css-extract-plugin
export default {"highlighted":"QVtPY","copy":"Rfrgy"};